import { render, staticRenderFns } from "./PlanejamentoContratoFormAcoesControle.vue?vue&type=template&id=004b46a7"
import script from "./PlanejamentoContratoFormAcoesControle.vue?vue&type=script&lang=js"
export * from "./PlanejamentoContratoFormAcoesControle.vue?vue&type=script&lang=js"
import style0 from "./PlanejamentoContratoFormAcoesControle.vue?vue&type=style&index=0&id=004b46a7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports